export default class ApiService {

	static get $inject(){
		return [
			'$q', '$http', '$cookies',
			'ApiService'
		];
	}

	constructor($q, $http, $cookies,
	            ApiService){

		this.api = ApiService.api;
		this.errors = ApiService.errors;
		this.successes = ApiService.successes;

		this.$q = $q;
		this.$http = $http;
		this.$cookies = $cookies;

	}

	get service(){
		return {

			setAlarmPanic: {
				name: 'setAlarmPanic',
				humanName: 'Panic Alarm',
				request: {
					type: 'PUT',
					route: '/personal/access/alarm/panic',
					data: [
						{ name: 'userCode', type: 'Integer', description: 'Optional user code' }
					],
					example: angular.toJson({ userCode: '1234' })
				},
				response: {
					success: { data: [
						this.successes.status,
						this.successes.state,
						this.successes.message
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data)=>
					this.$http({
						url: this.api + '/personal/access/alarm/panic',
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			resetGeneralAlarms: {
				name: 'resetGeneralAlarms',
				humanName: 'Reset general alarms',
				request: {
					type: 'PUT',
					route: '/personal/access/troubles',
					data: [
						{ name: 'userCode', type: 'Integer', description: 'Optional user code' }
					],
					example: angular.toJson({ userCode: '1234' })
				},
				response: {
					success: { data: [
						this.successes.status,
						this.successes.state,
						this.successes.message
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data)=>
					this.$http({
						url: this.api + '/personal/access/troubles',
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			setOutput: {
				name: 'setOutput',
				request: {
					type: 'PUT',
					route: '/personal/access/output/:outputId',
					data: [
						{ name: 'state', type: 'String', description: 'State to be set could be: ON/OFF' },
						{ name: 'userCode', type: 'Integer', description: 'Optional user code' }
					],
					example: angular.toJson({ state: 'ON', userCode: '1234' }),
					params: [
						{ name: 'outputId', type: 'Integer', description: 'Output ID (Zero based number)' }
					],
					param: ['0']
				},
				response: {
					success: { data: [
						this.successes.status,
						this.successes.state,
						this.successes.message
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/access/output/' + param,
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			setArea: {
				name: 'setArea',
				request: {
					type: 'PUT',
					route: '/personal/access/area/:areaId',
					data: [
						{ name: 'state', type: 'String', description: 'State to be set could be: ARM/STAY/DISARM/FORCE' },
						{ name: 'userCode', type: 'Integer', description: 'Optional user code' }
					],
					example: angular.toJson({ state: 'ARM', userCode: '1234' }),
					params: [
						{ name: 'areaId', type: 'Integer', description: 'Area ID (Zero based number)' }
					],
					param: ['0']
				},
				response: {
					success: { data: [
						this.successes.status,
						this.successes.state,
						this.successes.message
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/access/area/' + param,
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},
			///area/:areaId/reset
			setAreaReset: {
				name: 'setAreaReset',
				request: {
					type: 'PUT',
					route: '/personal/access/area/:areaId/reset',
					data: [
						//{ name: 'state', type: 'String', description: 'State to be set could be: ARM/STAY/DISARM/FORCE' },
						{ name: 'userCode', type: 'Integer', description: 'Optional user code' }
					],
					example: angular.toJson({ userCode: '1234' }),
					params: [
						{ name: 'areaId', type: 'Integer', description: 'Area ID (Zero based number)' }
					],
					param: ['0']
				},
				response: {
					success: { data: [
						this.successes.status,
						this.successes.state,
						this.successes.message
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/access/area/' + param + '/reset',
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			bypassZone: {
				name: 'bypassZone',
				request: {
					type: 'PUT',
					route: '/personal/access/zone/:zoneId',
					data: [
						{ name: 'userCode', type: 'Integer', description: 'Optional user code' }
					],
					example: angular.toJson({ userCode: '1234' }),
					params: [
						{ name: 'zoneId', type: 'Integer', description: 'Zone ID (Zero based number)' }
					],
					param: ['0']
				},
				response: {
					success: { data: [
						this.successes.status,
						this.successes.state,
						this.successes.message
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/access/zone/' + param,
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			takePicture: {
				name: 'takePicture',
				request: {
					type: 'PUT',
					route: '/personal/access/zone/:zoneId/takePicture',
					params: [
						{ name: 'zoneId', type: 'Integer', description: 'Zone ID (Zero based number)' }
					],
					param: ['14']
				},
				response: {
					success: { data: [
						{ name: 'filename', type: 'String', description: 'Url of taken picture' }
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/access/zone/' + param + '/takePicture',
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			}




			/*,
			 setAreaReset: {
			 name: 'setAreaReset',
			 request: {
			 type: 'PUT',
			 route: '/personal/access/area/reset',
			 data: [
			 { name: 'area', type: 'Integer', description: 'Area ID (Zero based number)' },
			 { name: 'userCode', type: 'Integer', description: 'Optional user code' }
			 ],
			 example: angular.toJson({ area: '0', state: 'ARM' })
			 },
			 response: {
			 success: { data: [] },
			 error: { data: [] }
			 },
			 submit: (data)=>
			 this.$http({
			 url: this.api + '/personal/access/reset/area',
			 method: 'PUT',
			 data: data,
			 headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
			 })
			 }*/

		}
	}


	//0013A102184B:SET_USER:FFFF1234:RESET_ALARM_AREA:0


}



/** WEBPACK FOOTER **
 ** ./src/main/apiTest/services/api.service.personal.access.actions.js
 **/